import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { getTeamNameHelper } from 'helper/matchDetailHelper';
import { fetchFullEvent } from 'stores/match';
import BetTitleAndBox from 'components/general/bet_title_and_box';

function StorySlide({ slide, onClose }) {
  const { t } = useTranslation('translations', { useSuspense: false });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const locales = useSelector((state) => state.match.locales);
  const selectedLocale = useSelector((state) => state.match.selectedLocale);
  const match = useSelector((state) =>
    slide.type === 'match_promo' && slide.matchId
      ? state.match.events[slide.matchId]
      : null
  );

  useEffect(() => {
    if (slide.type === 'match_promo' && slide.matchId && !match) {
      dispatch(fetchFullEvent(slide.matchId));
    }
  }, [dispatch, slide.type, slide.matchId, match]);

  const handleNavigate = (path) => {
    onClose();
    navigate(path);
  };

  if (slide.type === 'match_promo') {
    if (!match || !match.competitors || match.competitors.length < 2) {
      return (
        <div className="story-slide story-slide--match">
          <div className="story-slide__content">
            <p className="story-slide__text">{t('loading') || 'Loading...'}</p>
          </div>
        </div>
      );
    }

    const homeTeam = getTeamNameHelper(locales, selectedLocale, match.competitors[0], t);
    const awayTeam = getTeamNameHelper(locales, selectedLocale, match.competitors[1], t);

    const market = match.markets?.find((m) => m.id === slide.marketId);

    return (
      <div className="story-slide story-slide--match">
        <div className="story-slide__content">
          <div className="story-slide__teams">
            <span className="story-slide__team-name">{homeTeam}</span>
            <span className="story-slide__vs">VS</span>
            <span className="story-slide__team-name">{awayTeam}</span>
          </div>
          {market && (
            <div className="story-slide__odds" onClick={(e) => e.stopPropagation()}>
              <BetTitleAndBox
                market={market}
                matchId={match.providerId}
                sportType={match.sport}
                hideMarketNameInCard={false}
                marketCount={match.markets?.length || 0}
              />
            </div>
          )}
          <button
            className="btn btn-primary story-slide__action-btn"
            onClick={(e) => {
              e.stopPropagation();
              handleNavigate(`/match-detail#${match.providerId}`);
            }}
          >
            {t('goToMatch')}
          </button>
        </div>
      </div>
    );
  }

  if (slide.type === 'feature_promo') {
    return (
      <div className="story-slide story-slide--feature">
        <div className="story-slide__content">
          <h2 className="story-slide__title">{slide.title}</h2>
          <p className="story-slide__description">{slide.description}</p>
          {slide.link && (
            <button
              className="btn btn-outline-light story-slide__action-btn"
              onClick={(e) => {
                e.stopPropagation();
                handleNavigate(slide.link);
              }}
            >
              {t('learnMore')}
            </button>
          )}
        </div>
      </div>
    );
  }

  return null;
}

export default StorySlide;
